import { Component, OnInit } from '@angular/core';
import {Filtri} from "../../task/models/filtri";

@Component({
  selector: 'app-rma-unita',
  templateUrl: './pa-ticket.component.html',
  styles: [
  ]
})

export class PATicketComponent implements OnInit {
  today = new Date();
  public filter= new Filtri(0,10,undefined,true,undefined,undefined,this.today.getFullYear(),13);
  constructor() { this.filter.rma = true;}

  ngOnInit(): void {
  }

}
